module.exports = "/static/Images/es/Four.png";